// Tracking utilities for analytics

export const trackEvent = (eventName: string, parameters?: any) => {
  // Google Analytics tracking
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }

  // Facebook Pixel tracking
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, parameters);
  }
};

// Specific tracking functions
export const trackWhatsAppClick = () => {
  trackEvent('contact', {
    method: 'whatsapp',
    event_category: 'engagement',
    event_label: 'whatsapp_button_click'
  });
};

export const trackFormSubmission = (formType: string) => {
  trackEvent('form_submit', {
    form_type: formType,
    event_category: 'engagement',
    event_label: `${formType}_form_submission`
  });
};

export const trackQuotationRequest = () => {
  trackEvent('Lead', {
    value: 0.00,
    currency: 'USD',
    event_category: 'conversion',
    event_label: 'quotation_request'
  });
};

export const trackProductView = (productId: string, productName: string) => {
  trackEvent('view_item', {
    item_id: productId,
    item_name: productName,
    item_category: 'product',
    event_category: 'engagement',
    event_label: 'product_view'
  });
};